import { useCallback } from "react";
import { FileInputArea } from "@/components/flow/build/Steps/Upload/VisualAreaContent/FileInputArea";
import { ModalWithIcon } from "@scripts/react/components/RfModal/ModalWithIcon";
import { MediaItem } from "@/types/media";
import { useMedia } from "@/contexts/MediaContext";
import { UploadLimitErrorType } from "@/constants/media";

const Modal = ModalWithIcon as any;

interface FileUploadModalProps {
    isModalOpen: boolean;
    setIsModalOpen: (isOpen: boolean) => void;
    onAddMediaItems: (files: File[]) => void;
    title: string;
    erroredMediaItems?: MediaItem[];
    uploadLimitError?: UploadLimitErrorType | null;
    clearUploadLimitError?: () => void;
}

export const FileUploadModal = ({
    isModalOpen,
    setIsModalOpen,
    onAddMediaItems,
    title,
    erroredMediaItems = [],
    uploadLimitError: uploadLimitErrorProp,
    clearUploadLimitError: clearUploadLimitErrorProp
}: FileUploadModalProps) => {
    const { clearUploadLimitError: clearUploadLimitErrorFromContext } = useMedia();

    // Use props if provided, otherwise fall back to context
    const clearUploadLimitError = clearUploadLimitErrorProp ?? clearUploadLimitErrorFromContext;

    const handleClose = useCallback(() => {
        clearUploadLimitError();
        setIsModalOpen(false);
    }, [clearUploadLimitError, setIsModalOpen]);

    return (
        <Modal
            isOpen={isModalOpen}
            onClose={handleClose}
            type="info"
            size="xl"
            icon="fad fa-upload"
            title={title}
            showFooter={false}
        >
            <FileInputArea
                addMediaItems={onAddMediaItems}
                erroredMediaItems={erroredMediaItems}
                qrSize={90}
                showAllMethods={true}
                uploadLimitError={uploadLimitErrorProp}
                clearUploadLimitError={clearUploadLimitError}
            />
        </Modal>
    );
};
